import { SET_ACTIVE_MANAGE_EVENT_ID } from '../actions/activeManageEventId';

const activeManageEventId = (state = '', action) => {
  switch(action.type) {
    case SET_ACTIVE_MANAGE_EVENT_ID:
      return action.activeEvent;
    default:
      return state;
  }
};

export default activeManageEventId;



// WEBPACK FOOTER //
// ./src/redux/reducers/activeManageEventId.js